import {authHeaders, baseUrl, handleResponse} from "./apiUtils";

function getAccountPermissions() {
  return fetch(`${baseUrl}permissions/accounts`, {
    headers: authHeaders(),
  }).then(handleResponse);
}

function updateAccountPermissions(accountId, patch) {
  return fetch(`${baseUrl}permissions/accounts/${encodeURIComponent(accountId)}`, {
    method: "PUT",
    headers: authHeaders({ "content-type": "application/json" }),
    body: JSON.stringify(patch),
  }).then(handleResponse);
}

function createAccountFromProfile(payload) {
  return fetch(`${baseUrl}permissions/accounts`, {
    method: "POST",
    headers: authHeaders({ "content-type": "application/json" }),
    body: JSON.stringify(payload),
  }).then(handleResponse);
}

export default {
  createAccountFromProfile,
  getAccountPermissions,
  updateAccountPermissions,
};
